import files from 'file-saver'
import api from '@/api'
import {getHeaderName} from '@/utils'
import {
  SET_EXPORTING,
} from './mutation-types'

const state = {
  exporting: {
    1: false,
    2: false,
  },
}

const mutations = {
  [SET_EXPORTING] (state, payload) {
    state.exporting[payload.type] = payload.status
  },
}

const actions = {
  // 获取插件列表
  async getPluginList ({commit, state}, payload) {
    const {data} = await api.deployApi.getPluginList(payload)
    return data
  },
  // 获取插件配置列表
  async getPluginConfigList({commit, state}, payload) {
    const {data} = await api.deployApi.getPluginConfigList(payload)
    return data
  },
  async importExcelPlugin ({state}, payload) {
    const data = await api.deployApi.importExcelPlugin(payload)
    return data
  },
  async exportPluginTemplateExcel ({commit, state}) {
    try {
      commit(SET_EXPORTING, {type: 1, status: true})
      const {data, headers} = await api.deployApi.exportPluginTemplateExcel()
      commit(SET_EXPORTING, {type: 1, status: false})
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/octet-stream' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_EXPORTING, {type: 1, status: false})
    }
  },
  async exportPluginDateExcel ({commit, state}, payload) {
    try {
      commit(SET_EXPORTING, {type: 2, status: true})
      const {data, headers} = await api.deployApi.exportPluginDataExcel(payload)
      commit(SET_EXPORTING, {type: 2, status: false})
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/octet-stream' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_EXPORTING, {type: 2, status: false})
    }
  },
  async addPluginConfig ({state}, payload) {
    const data = await api.deployApi.addPluginConfig(payload)
    return data
  },
  async deletePluginConfig ({state}, payload) {
    const data = await api.deployApi.deletePluginConfig(payload)
    return data
  },
  async addPlugin ({state}, payload) {
    const data = await api.deployApi.addPlugin(payload)
    return data
  },
  async dealPlugin ({state}, payload) {
    const data = await api.deployApi.dealPlugin(payload)
    return data
  },
  async deletePlugin ({state}, payload) {
    const data = await api.deployApi.deletePlugin(payload)
    return data
  },
  async pluginAllocatePlatform ({state}, payload) {
    const {code} = await api.deployApi.pluginAllocatePlatform(payload)
    return code
  },
  async pluginAllocateOS ({state}, payload) {
    const {code} = await api.deployApi.pluginAllocateOS(payload)
    return code
  },
  async allocateCV ({state}, payload) {
    const {code} = await api.deployApi.allocateCV(payload)
    return code
  },
  async modifyOpenStatus ({state}, payload) {
    const {code} = await api.deployApi.modifyOpenStatus(payload)
    return code
  },
  async getCgPluginControlPullSelect ({state}, payload) {
    const {data} = await api.deployApi.getCgPluginControlPullSelect(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
